export default __webpack_public_path__ + "f4c530ea927e45916dfb062c7accd8f1.png";